// extracted by mini-css-extract-plugin
export var authorDetailsWrapper = "ArticleAuthorDetails-module--authorDetailsWrapper--1dCT5";
export var image = "ArticleAuthorDetails-module--image--3ooic";
export var nameRow = "ArticleAuthorDetails-module--nameRow--18Z2R";
export var name = "ArticleAuthorDetails-module--name--3MP2e";
export var details = "ArticleAuthorDetails-module--details--3dtJ-";